<template>
  <div :class="$style.page">
    <Header :showCenter="false" />

    <div :class="$style.content">
      <div :class="$style.content_left">
        <img
          :class="$style.banner"
          src="@assets/image/login_bg.png"
          alt="banner"
        />
      </div>

      <div :class="$style.content_right">
        <Loading :loading="loading" icon="el-icon-loading" text="注册中...">
          <div :class="$style.form">
            <Row :class="$style.logo">
              <img src="@assets/image/logo.png" alt="logo" />
            </Row>

            <Row>
              <el-input
                v-model.trim="phone"
                placeholder="手机号码/邮箱"
              >
                <img
                  slot="prefix"
                  src="@assets/image/phone.png"
                  alt="account"
                />
              </el-input>
            </Row>

            <Row>
              <el-input
                v-model.trim="captchaCode"
                placeholder="验证码"
                maxlength="6"
              />
              <el-button
                  class="codeBtn"
                  @click="refreshCode"
                  :disabled="codeDisabled"
                  style="color: #ff5c35; border: 1px solid #ff5c35;margin-left: .2rem !important;"
              >
                {{ text1 }}
              </el-button>
            </Row>

            <!-- 占位input，防止密码框的上一个input被填充 -->
            <div style="display: flex; height: 0">
              <input style="height: 0; border: none" />
            </div>

            <Row>
              <el-input
                v-model.trim="password"
                placeholder="请输入密码"
                maxlength="16"
                type="password"
                autocomplete="new-password"
                show-password
              >
                <img slot="prefix" src="@assets/image/lock.png" alt="lock" />
              </el-input>
            </Row>

            <Row>
              <el-input
                v-model.trim="confirmPassword"
                placeholder="请确认密码"
                maxlength="16"
                type="password"
                autocomplete="new-password"
                show-password
              >
                <img slot="prefix" src="@assets/image/lock.png" alt="lock" />
              </el-input>
            </Row>

            <Row>
              <div :class="$style.agree">
                <el-checkbox :class="$style.agree_check" v-model="agree">
                  <span :class="$style.agree_label">
                    我已阅读并同意
                    <span
                      ><AgreementPopup :title="mTitle" :content="mContent"
                    /></span>
                    和
                    <span
                      ><AgreementPopup :title="pTitle" :content="pContent"
                    /></span>
                  </span>
                </el-checkbox>
              </div>
            </Row>

            <Row>
              <Button
                :class="$style.register_btn"
                type="primary"
                @click="clickRegister"
              >
                立即注册
              </Button>
            </Row>

            <Row :class="$style.form_bottom">
              已经有'识道网络'账户 ?
              <router-link to="/login" :class="$style.login_link">
                立即登录
              </router-link>
            </Row>
          </div>
        </Loading>
      </div>
    </div>

    <Footer />
    <el-dialog width="40%" title="验证码" :visible.sync="verifyshow" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="verify-info">
        <div class="verify-code">
          <span class="verify-label">验证码</span>
          <div class="verify-block">
            <img id="verificationCode" class="verify-img" @click="refreshCode">
          </div>
        </div>
        <input
            v-model="codeValue"
            class="verify-input"
            placeholder="请输入验证码"
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="verifyshow = false">取 消</el-button>
        <el-button type="primary"  @click="getCodeEvent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "@components/Header.vue";
import Footer from "@components/Footer.vue";
import AgreementPopup from "@components/AgreementPopup.vue";
import privacyRules from "@constant/privacyRules";
import serviceRules from "@constant/serviceRules";

import { getPublicKey, register } from "@server";
import { validPhone, validEmail, encryptPwd } from "@utils";
import {  getRegisterCode } from "@server";
import { API_BASE_URL } from '@utils/config';

export default {
  name: "Register",
  components: {
    Header,
    Footer,
    AgreementPopup,
  },
  data() {
    return {
      phone: "", // 手机号
      captchaCode: "", // 验证码
      password: "", // 密码
      confirmPassword: "", // 确认密码

      loading: false,
      agree: false,
      // 服务协议
      mTitle: serviceRules.title,
      mContent: serviceRules.content,
      // 隐私声明
      pTitle: privacyRules.title,
      pContent: privacyRules.content,
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text1: "获取验证码",
      codeDisabled: false
    };
  },
  methods: {
    refreshCode() {
      if (!this.phone || this.phone === '') {
        return this.$message.warning('手机号/邮箱不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${API_BASE_URL}/hbsdweb/sms/register/validateCode?mobile=${this.phone}`
      }, 0)
    },
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$message.warning("图形验证码不能为空！");
      }
      if (!validPhone(this.phone) && !validEmail(this.phone)) {
        this.$message.warning("请输入正确的手机号码或邮箱！");
        return;
      }
      getRegisterCode(this.phone, this.codeValue)
          .then((res) => {
            if (res.code === 200 && res.result) {
              let i = 60;
              this.text1 = `${i--}秒后再获取`;
              this.codeDisabled = true
              this.verifyshow = false
              this.getCodeInterval = setInterval(() => {
                if (i <= 1) {
                  this.text1 = "获取验证码";
                  clearInterval(this.getCodeInterval);
                  this.codeDisabled = false
                  return;
                }
                this.text1 = `${i--}秒后再获取`;
              }, 1000);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {
          });
    },
    async getPublicKey() {
      if (!this.$storage.getPublicKey()) {
        const res = await getPublicKey();
        res.code == 200 && this.$storage.setPublicKey(res.data);
      }
    },

    checkRegister() {
      if (!this.phone) {
        this.$message({ message: "请输入手机号/邮箱", type: "warning" });
        return false;
      }

      if (!validPhone(this.phone) && !validEmail(this.phone)) {
        this.$message({ message: "请输入正确的手机号/邮箱", type: "warning" });
        return false;
      }

      if (this.captchaCode.length !== 6) {
        this.$message({
          message: `请输入${this.captchaCode ? "正确的" : ""}验证码`,
          type: "warning",
        });
        return false;
      }

      if (this.password.length < 8) {
        this.$message({ message: "请输入 8-16 位字符的密码", type: "warning" });
        return false;
      }

      if (!this.confirmPassword) {
        this.$message({ message: "请再次确认输入密码", type: "warning" });
        return false;
      }

      if (this.password !== this.confirmPassword) {
        this.$message({ message: "两次密码输入不一致", type: "warning" });
        return false;
      }
      if (!this.agree) {
        this.$message({
          message: "请阅读并同意《服务协议》和 《隐私声明》",
          type: "warning",
        });
        return false;
      }
      return true;
    },

    async clickRegister() {
      if (!this.checkRegister()) return;

      this.loading = true;
      const params = {
        mobile: this.phone,
        smsCode: this.captchaCode,
        password: encryptPwd(this.password),
        password2: encryptPwd(this.confirmPassword), //确认密码
        source: 1,
        parentId: 0,
      };
      const res = await register(params);

      if (res.code === 200) {
        this.$message({ message: "注册成功，快去登录吧!", type: "success" });
        setTimeout(() => {
          this.$router.replace("/login");
        }, 1000);
      } else {
        this.$message({ message: res.message, type: "error" });
      }
      this.loading = false;
    },
  },
  created() {
    this.getPublicKey();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;

  :global {
    .gl-row {
      margin-bottom: rem(30);
      justify-content: space-between;
    }

    .gl-button {
      margin: 0;
    }

    ::v-deep .el-input {
      &.el-input--prefix {
        .el-input__inner {
          padding-left: rem(56);
        }
      }

      .el-input__prefix {
        left: 0;
        width: rem(56);
        @include flex();

        img {
          width: max(rem(16), 12px);
          object-fit: cover;
        }
      }
    }
  }

  .content {
    flex: 1;
    margin: rem(60) auto;
    padding-top: rem(80);
    display: flex;
    justify-content: center;

    .content_left {
      width: rem(820);
      height: rem(680);
      margin-right: rem(60);

      .banner {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .content_right {
      box-sizing: border-box;
      width: rem(490);
      height: rem(680);
      padding: rem(24) rem(60);
      background: #fff;
      box-shadow: 0px 5px 18px 0px rgba(0, 0, 0, 0.06);
      border: $border-1;
      border-radius: 4px;
      .agree {
        @include flex();

        .agree_check {
          margin-left: auto;
          margin-right: 10px;

          :global {
            ::v-deep .el-checkbox__inner {
              border-radius: 50%;
            }
          }
        }

        .agree_label {
          font-size: rem(14);
          color: #555;
        }
      }
    }
  }

  .form {
    .logo {
      height: rem(120);
      @include flex();

      img {
        height: rem(54);
        object-fit: cover;
      }
    }

    .register_btn {
      width: 100%;
    }

    .form_bottom {
      font-size: rem(14);
      color: #333;

      .login_link {
        margin-left: 4px;
        color: $theme-color;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
<style>
.verify-info {
  padding: 15px 30px;
}
.verify-label {
  background-color: #f7fafb;
  width: 80px;
  font-size: 14px;
  padding: 0 15px;
  line-height: 58px;
  text-align: center;
}
.verify-code {
  border: 1px solid #e9eaec;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.verify-input {
  display: block;
  width: 100%;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  outline: none;
  padding: 0 20px;
  line-height: 40px;
  box-sizing: border-box;
}
.verify-block {
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-left: 10px;
}
.el-button--primary {
  color: #FFF;
  background-color: #ff5c35;
  border-color: #ff5c35;
}
</style>
